import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { listOfUseCasesResponse } from '@/store/api/RunReport/RunReport.types'

import { UseCaseGuidelineSheet } from '../../Search/components/UseCaseGuidelineSheet'

interface UseCaseSectionTypes {
  data?: listOfUseCasesResponse
  handleUseCaseChange: any
  selectedUseCaseName?: string
  language: string
}

export const UseCaseFollowUpReportSection = ({
  data,
  handleUseCaseChange,
  selectedUseCaseName,
  language,
}: UseCaseSectionTypes) => {
  const { t } = useTranslation()

  const companySearchUseCases = data?.info.filter(
    (useCase) => useCase.isForCompanySearch,
  )

  const individualSearchUseCases = data?.info.filter(
    (useCase) => !useCase.isForCompanySearch,
  )

  return (
    <div className="flex flex-col gap-6 w-1/2">
      <div className="flex flex-col gap-3 items-center">
        <p className="text-center text-neutralColor text-xl font-medium">
          {t('dashboard.newSearch.useCases.title')}
        </p>
        <span className="text-center text-neutralColor80 text-base font-normal">
          {t('dashboard.newSearch.useCases.subtitle')}
          <UseCaseGuidelineSheet data={data?.info} language={language} />
        </span>
      </div>
      <div className="flex gap-3 max-md:flex-col">
        <Select onValueChange={handleUseCaseChange}>
          <SelectTrigger className="h-[46px] rounded-lg">
            <SelectValue
              placeholder={
                selectedUseCaseName !== ''
                  ? selectedUseCaseName
                  : t('dashboard.newSearch.useCases.selectUseCase')
              }
            />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              <SelectLabel>
                {t('dashboard.newSearch.useCases.individualSearch')}
              </SelectLabel>
              {individualSearchUseCases?.map((useCase) => {
                const translation = useCase.translations.find(
                  (t) => t.language === language,
                )
                return (
                  <div className="flex items-center hover:bg-primaryColor5 gap-2">
                    <SelectItem
                      hiddenCheckIcon
                      key={`usecase-${translation?.name}-${useCase._id}`}
                      value={useCase._id || ''}
                    >
                      <p>{translation?.name}</p>
                    </SelectItem>
                  </div>
                )
              })}

              <SelectSeparator />

              <SelectLabel>
                {t('dashboard.newSearch.useCases.companySearch')}
              </SelectLabel>
              {companySearchUseCases?.map((useCase) => {
                const translation = useCase.translations.find(
                  (t) => t.language === language,
                )
                return (
                  <SelectItem
                    hiddenCheckIcon
                    value={useCase._id || ''}
                    key={`usecase-${translation?.name}-${useCase._id}`}
                  >
                    <p>{translation?.name}</p>
                  </SelectItem>
                )
              })}
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}
